import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Provider, useStore } from 'react-redux';
import Grid from '../../../components/partials/Grid';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import { parseCSVToGrid } from '../../../utils/csvUtils';
import css from './GridArtifact.css';

const GridArtifact = ({ artifact }) => {
    const { data, metadata } = artifact;
    const store = useStore();

    const { rowData, columnDefs } = useMemo(() => {
        if (!data) {
            return { rowData: [], columnDefs: [] };
        }

        if (typeof data === 'string') return parseCSVToGrid(data);

        return { rowData: [], columnDefs: [] };
    }, [data]);

    const gridId = `artifact-grid-${artifact.id}`;

    if (!rowData || rowData.length === 0) {
        return (
            <div className={css.emptyState}>
                <Icon name="table" size={IconSizes.LARGE} />
                <div>No data available</div>
            </div>
        );
    }

    return (
        <div className={css.gridArtifact}>
            <div className={css.gridWrapper}>
                <Provider store={store}>
                    <Grid
                        id={gridId}
                        key={gridId}
                        columnDefs={columnDefs}
                        rowData={rowData}
                        reportType="reports"
                        queryObject={{}}
                        columnTypes={{}}
                        hideResetTable
                        hidePivotHeaders
                        hideColumnsSideBar
                        disableScrollingHooks
                        disableUrlSync
                        heightOverride={500}
                    />
                </Provider>
            </div>
            {metadata?.is_truncated && (
                <div className={css.truncationWarning}>
                    <Icon name="info-circle" variant={IconVariants.WARNING} size={IconSizes.SMALL} />
                    <span>
                        {metadata.truncation_message ||
                            `Showing ${metadata.display_row_count} of ${metadata.row_count} rows`}
                    </span>
                </div>
            )}
        </div>
    );
};

GridArtifact.propTypes = {
    artifact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        data: PropTypes.string,
        metadata: PropTypes.shape({
            display_row_count: PropTypes.number,
            is_truncated: PropTypes.bool,
            row_count: PropTypes.number,
            truncation_message: PropTypes.string,
        }),
    }).isRequired,
};

export default GridArtifact;
